"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBaseModalStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../style/_colors");
exports.useBaseModalStyles = core_1.makeStyles(function () { return ({
    root: {
        margin: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    small: { maxWidth: 400, maxHeight: 250 },
    medium: { maxWidth: 680, maxHeight: 370 },
    paper: {
        width: '100%',
        padding: 32,
        outline: 'none',
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 8,
    },
    backDrop: {
        backgroundColor: _colors_1.darkGreenBlue,
        opacity: '0.8 !important',
    },
}); });
